import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-tax-office-abbr',
  templateUrl: './tax-office-abbr.component.html',
  standalone: false,
})
export class TaxOfficeAbbrComponent implements OnChanges {
  @Input() regimeId: number;

  ngOnChanges() {
    this.assertRegime();
  }

  assertRegime(): asserts this is { regimeId: 5 | 100 } {
    switch (this.regimeId) {
      case 5:
      case 100:
        return;

      default:
        throw new Error('Unrecognised regimeId: ' + this.regimeId);
    }
  }
}
